import { render, staticRenderFns } from "./TariffsTabs.vue?vue&type=template&id=d135ccae&"
import script from "./TariffsTabs.vue?vue&type=script&lang=js&"
export * from "./TariffsTabs.vue?vue&type=script&lang=js&"
import style0 from "./TariffsTabs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports